import { render, staticRenderFns } from "./_DialogHeader.vue?vue&type=template&id=6e8d832d"
import script from "./_DialogHeader.vue?vue&type=script&lang=js"
export * from "./_DialogHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports